// Error message to show when an unexpected error happens:
export const genericErrorMessage =
  "Une erreur inconnue s'est produite. Veuillez nous excuser. Vous pouvez nous contacter via l'application de chat en bas à droite.";

export const translatedErrors: { [key: string]: string } = {
  // Please keep this list in alphabetical order:
  ACCOUNT_ALREADY_ACTIVATED:
    'Vous avez déjà activé votre compte. Merci de vous connecter à votre compte.',
  ACCOUNT_DELETED:
    'Cette adresse e-mail appartient à un compte qui a été supprimé.',
  ALREADY_SENT_MAIL:
    "Vous avez fait trop de demandes d'envoi d'e-mail. Merci de réessayer ultérieurement.",
  ALREADY_SUBSCRIBED: 'Vous avez déjà souscrit à un plan.',
  ASK_DECISION_ALLOWED:
    'Le service de demande de documents est réservé à nos clients',
  AUTOMATIC_SIGNUP_NOT_VERIFIED: `Cette adresse e-mail appartient à un compte non activé. Un e-mail permettant de finaliser l'activation de votre compte a été envoyé à cette adresse`,
  CANCELLED_BECAUSE_OF_NEWER_QUERY:
    'Anomalie dans la réponse du serveur (CANCELLED_BECAUSE_OF_NEWER_QUERY). Merci de nous contacter pour nous signaler ce problème.',
  CANNOT_SEND_SMS_TO_LANDLINE:
    'Le numéro que vous avez entré correspond à une ligne fixe et ne peut donc pas recevoir de SMS.',
  CAPTCHA_FAILURE: 'Réponse au CAPTCHA incorrecte',
  CAPTCHA_MISSING: 'Merci de remplir le CAPTCHA',
  CHANGE_EMAIL_NOT_VERIFIED:
    'Vous devez vérifier votre compte avec votre numéro de téléphone avant de pouvoir changer votre email.',
  CHARGEBEE_API_ISSUE_CREATE:
    "Nous n'avons pas pu ajouter votre carte. Aucun prélèvement n'a été effectué sur votre compte. Vous pouvez contacter le service client pour plus d'informations",
  CHARGEBEE_API_ISSUE_LIST:
    "Nous n'avons pas pu récupérer vos informations de paiement, veuillez réessayer ultérieurement ou contacter le service client.",
  DOC_ID_NOT_FOUND: 'doc_id non trouvé',
  EMAIL_ALREADY_USED:
    'Cette adresse email est déjà utilisée par un autre utilisateur.',
  EMAIL_NOT_VERIFIED:
    'Votre email n’a pas été confirmé. Vous pouvez demander un renvoi d’email en cliquant sur ”Mot de passe oublié” ci-dessous.',
  FOLDER_ALREADY_EXISTS: 'Vous avez déjà un dossier avec ce nom.',
  IMPRECISE_SEARCH:
    "Désolé, votre recherche n'est pas assez précise, essayez de mettre plus de mots.",
  INCORRECT_PASSWORD: 'Mot de passe incorrect ou compte inexistant',
  INCORRECT_ACCOUNT_PASSWORD: 'Mot de passe incorrect',
  INVALID_AGREED_TO_TERMS: 'Veuillez lire et accepter les CGU et les CGV.',
  INVALID_BARREAU: 'Barreau invalide',
  INVALID_COUPON: "Le coupon n'est pas valide.",
  INVALID_DATE: "La date que vous avez entrée n'est pas valide.",
  INVALID_EMAIL: 'Votre adresse e-mail semble incorrecte.',
  INVALID_FIRM_SIZE: 'La taille de votre structure est invalide.',
  INVALID_LAWYER_ID: 'Le lawyer id est incorrect.',
  INVALID_METIER: 'Veuillez entrer un métier valide.',
  INVALID_PASSWORD_RESET_CODE:
    "Ce lien de choix de mot de passe n'est plus valable. Peut-être avez-vous déjà choisi votre mot de passe ?",
  INVALID_PASSWORD: "Veuillez choisir un mot de passe d'au moins 8 caractères",
  INVALID_PHONE_NUMBER:
    "Le numéro de téléphone que vous avez saisi n'est pas valide.",
  INVALID_PHONE_VERIFICATION_CODE: 'Le code de vérification est incorrect.',
  INVALID_POSITION: 'Veuillez entrer un rôle valide.',
  INVALID_POSTAL_ADDRESS: 'Veuillez remplir tous les champs.',
  INVALID_URL_FORMAT: "Le format de l'URL est incorrect.",
  INVALID_URL_HTTP_PREFIX: "L'URL doit commencer par http:// ou https://",
  INVALID_URL_TOP_LEVEL_DOMAIN: "L'URL est invalide ou incomplète.",
  INVALID_USER_ID: 'Le user id est incorrect.',
  LANGUAGE_ALREADY_PRESENT: 'Cette langue est déjà présente.',
  MISSING_AGREED_TO_TERMS: 'Veuillez lire et accepter les CGU et les CGV.',
  MISSING_COUPON: 'Veuillez entrer votre coupon.',
  MISSING_EMAIL: 'Veuillez entrer votre adresse e-mail.',
  MISSING_FIELDS: "Vous n'avez pas rempli tous les champs.",
  MISSING_FIRM_SIZE: 'Veuillez entrer la taille de votre structure.',
  MISSING_FIRST_NAME: 'Veuillez renseigner un prénom.',
  MISSING_LAST_NAME: 'Veuillez renseigner un nom.',
  MISSING_METIER: 'Veuillez entrer votre métier.',
  MISSING_PASSWORD: 'Veuillez entrer votre mot de passe.',
  MISSING_POSITION: 'Veuillez entrer votre rôle.',
  MISSING_TITLE: 'Veuillez entrer un titre.',
  MISSING_URL: 'Veuillez entrer une URL.',
  MUST_USE_LINKEDIN:
    'Vous devez utiliser LinkedIn pour vous connecter à votre compte.',
  NEW_VERSION_PLEASE_RELOAD:
    'L’application a été mise à jour. Veuillez rafraîchir la page pour vous inscrire.',
  NO_EMAIL_AVAILABLE: 'L’email de cet avocat n’est pas disponible.',
  NO_ROW_AFFECTED: 'Aucune ligne affectée',
  PHONE_NUMBER_ALREADY_USED:
    'Ce numéro de téléphone est déjà utilisé par un autre utilisateur.',
  PHONE_NUMBER_ALREADY_VERIFIED:
    'Vous avez déjà vérifié votre numéro de téléphone. Il vous suffit de vous connecter pour avoir accès à Doctrine.',
  PRO_EMAIL_REQUIRED:
    "Veuillez entrer l'adresse e-mail de votre structure et non votre adresse personnelle.",
  PROFESSIONAL_IMG_SIZE_EXCEEDED:
    'Désolé, la taille de votre image est trop élevée (limite 10Mo)',
  PROFESSIONAL_IMG_WRONG_FILE_TYPE:
    'Désolé, votre photo de profil doit être au format .jpg, .jpeg, .png ou .tiff.',
  RELOAD_PAGE: "Veuillez recharger la page s'il vous plaît.",
  RETRY_LATER:
    'Vous avez fait trop de tentatives. Merci de réessayer dans quelques minutes.',
  SEARCH_QUOTA_EXCEEDED: 'Vous devez être connecté pour continuer à chercher',
  SHOULD_DISABLE_ACCOUNT_FIRST: 'Cette adresse email est déjà utilisée.',
  SIZE_LIMIT_EXCEEDED: 'Taille limite dépassée',
  SKILL_ALREADY_PRESENT: 'Ce domaine d’activité est déjà présent.',
  TITLE_SIZE_LIMIT_EXCEEDED: 'Taille limite dépassée pour le titre.',
  TOO_LONG_EXTRACT: 'L’extrait sélectionné est trop long',
  TOO_LONG_QUERY: 'Désolé, votre recherche est trop longue.',
  TOO_MANY_ACCOUNTS:
    "Vous avez tenté d'enregistrer trop de comptes dans un laps de temps trop court.",
  TOO_MANY_PHONE_VERIF: 'Vous avez essayé trop de codes.',
  TOO_MANY_REQUESTS:
    "Désolé, vous avez effectué trop de recherches trop rapidement. Merci de réessayer dans quelques secondes. Si le problème persiste, n'hésitez pas à nous contacter.",
  TOO_MANY_RESULTS_REQUESTED: 'Trop de résultats demandés.',
  TOO_MANY_SMS_SENT: 'Vous avez fait trop de demandes de SMS.',
  TRIAL_EXPIRED:
    'Votre essai gratuit est terminé. Abonnez-vous pour bénéficier de Doctrine.',
  URL_IS_ALREADY_IN_LIST: 'Vous avez déjà ajouté cet article à votre liste.',
  URL_SIZE_LIMIT_EXCEEDED: "Taille limite dépassée pour l'url.",
} as const;

/* Extract error message form AJAX call response. */
/* If no message is given, return a generic error message. */
/* eslint-disable camelcase */
export const getErrorMessage = (response: {
  data?: { error_message?: string; error?: string };
  /* eslint-enable camelcase */
}) => {
  if (response.data) {
    if (response.data.error_message) {
      return response.data.error_message;
    }
    if (response.data.error && response.data.error in translatedErrors) {
      return translatedErrors[response.data.error];
    }
  }
  return genericErrorMessage;
};
